/**
 * Created by shubham on 27/2/18.
 */

import { Injectable } from '@angular/core';

@Injectable()
export class SessionHandler {
    public prevUrl:any;

    constructor() { }

    saveItem(key,value){
        localStorage.setItem(key,value);
    }

    getItem(key){;
        return localStorage.getItem(key);
    }

    removeItem(key){
        localStorage.removeItem(key);
    }

    clearAllItems(){
        localStorage.clear();
    }

    setRedirectionUrl(prevUrl: any) {
        this.prevUrl = prevUrl;
    }

    getRedirectionUrl() {
        return this.prevUrl;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/services/session-handler.service.ts